import * as React from 'react';
import { LabelConfig } from '../types';
import styles from './input-label.scss';
import { MdOutlineAutoAwesome } from 'react-icons/md';

export const InputLabel = (props: LabelConfig) => {
  return props.visible !== false ?
    <>
      {!!props.text && !!props.meatballPanelConfiguration?.panel
        ? <div className={styles.meatballPanelWithText}>{props.meatballPanelConfiguration.panel}</div>
        : null}
      <div className={`${props.meatballPanelConfiguration ? styles.meatballControlPanel : 'control-label'} ${props.className ?? ''}`}>
        <span>
          {props.required ? <span className="asterisk-required">* </span> : null}
          {props.icon ? <span className={`default-icon ${props.icon}`} /> : null}
          {props.showAIChatIcon && <MdOutlineAutoAwesome className={styles.aiChatIcon} />}
          {props.text}{!!props.additionalText && <span className={styles.additionalText}> ({props.additionalText})</span>}
          {!props.text && props.meatballPanelConfiguration?.panel
            ? <span className={styles.panel}>{props.meatballPanelConfiguration?.panel}</span>
            : null}
          {props.children}
        </span>
        {props.meatballPanelConfiguration?.meatball}
      </div>
    </> : null;
};
